import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X } from 'lucide-react';

interface ShortsModalProps {
  isOpen: boolean;
  onClose: () => void;
  shortId: string;
  title: string;
}

const ShortsModal: React.FC<ShortsModalProps> = ({ 
  isOpen, 
  onClose, 
  shortId, 
  title 
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-sm p-0 border-0 bg-black">
        <div className="relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 rounded-full bg-black/50 p-2 text-white hover:bg-black/70 transition-colors"
            aria-label="Close modal"
          >
            <X size={20} />
          </button>
          
          <div className="aspect-[9/16] w-full">
            <iframe
              src={`https://www.youtube.com/embed/${shortId}?autoplay=1&mute=0&loop=1&playlist=${shortId}&controls=1&modestbranding=1&rel=0`}
              title={title}
              allow="autoplay; encrypted-media; fullscreen"
              allowFullScreen
              className="h-full w-full"
              style={{ border: 'none', outline: 'none' }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShortsModal;